// utils/dateUtils.js
import { format, isToday, isYesterday, isThisWeek, subDays, formatDistanceToNow } from 'date-fns';

const formatDate = (date) => {
  const dateObj = new Date(date);
  if (isToday(dateObj)) {
    return `Today`;
  } else if (isYesterday(dateObj)) {
    return `Yesterday`;
  } else if (isThisWeek(dateObj)) {
    return `${format(dateObj, 'iiii')}`;
  } else {
    return format(dateObj, 'dd MMM yyyy');
  }
};

const formatTime = (date) => {
  return format(new Date(date), 'HH:mm');
};

const formatRelativeDate = (date) => {
  const dateObj = new Date(date);
  return formatDistanceToNow(dateObj, { addSuffix: true });
};

const formatFullDateTime = (date) => {
  return format(new Date(date), 'dd MMM yyyy, HH:mm');
};

const formatForPastDays = (date) => {
  const dateObj = new Date(date);
  const daysAgo = subDays(new Date(), 3);
  return isThisWeek(dateObj) && dateObj < daysAgo ? format(dateObj, 'iiii') : formatDate(date);
};

const formatDateWithSuffix = (dateString) => {
  const dateParts = dateString.split('/');
  const day = parseInt(dateParts[0], 10);
  const month = parseInt(dateParts[1], 10);
  const year = dateParts[2];

  const suffix = (day) => {
    if (day > 3 && day < 21) return 'th'; // Handle 11th to 19th
    switch (day % 10) {
      case 1:
        return 'st';
      case 2:
        return 'nd';
      case 3:
        return 'rd';
      default:
        return 'th';
    }
  };

  const monthNames = [
    'January',
    'February',
    'March',
    'April',
    'May',
    'June',
    'July',
    'August',
    'September',
    'October',
    'November',
    'December',
  ];

  return `${day}${suffix(day)} ${monthNames[month - 1]}, ${year}`;
};

export { formatDate, formatTime, formatRelativeDate, formatFullDateTime, formatForPastDays, formatDateWithSuffix };
